// extracted by mini-css-extract-plugin
export default {"inputCustom":"classes_inputCustom__4qPVC","dropdownItem":"classes_dropdownItem__iquHa","borderBottom":"classes_borderBottom__gVsPx"};